import { EEventType, type IGeneralEvent } from '@mahawi/eshop-rabbit/message';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React from 'react';

import {
  ENotificationSeverity,
  type ShowNotificationMessage,
} from '../../admin-types';

dayjs.extend(relativeTime);

interface EventGeneralProps {
  message: IGeneralEvent;
  showNotification: (params: { message: ShowNotificationMessage }) => void;
}

// Map event types to severity levels for better performance
const EVENT_TYPE_TO_SEVERITY: Record<EEventType, ENotificationSeverity> = {
  [EEventType.ERROR]: ENotificationSeverity.ERROR,
  [EEventType.DELETE]: ENotificationSeverity.WARNING,
  [EEventType.UPDATE]: ENotificationSeverity.INFO,
  [EEventType.CREATE]: ENotificationSeverity.SUCCESS,
  [EEventType.SUCCESS]: ENotificationSeverity.SUCCESS,
  [EEventType.DISCONNECT]: ENotificationSeverity.WARNING,
  [EEventType.SYNCED_WITH_WAREHOUSE]: ENotificationSeverity.SUCCESS,
} as const;

const getSeverity = (eventType: EEventType): ENotificationSeverity =>
  EVENT_TYPE_TO_SEVERITY[eventType] ?? ENotificationSeverity.INFO;

const createDescription = (
  description: string,
  timestamp: string,
): React.ReactElement => (
  <div>
    <p>{description}</p>
    <p>
      <Typography.Text strong>Timestamp:</Typography.Text> {timestamp}
    </p>
  </div>
);

export const eventGeneral = ({
  message,
  showNotification,
}: EventGeneralProps): void => {
  const severity: ENotificationSeverity = getSeverity(message.event.type);
  const timestamp: string = dayjs(message.timestamp * 1000).fromNow();
  const description: React.ReactElement = createDescription(
    message.description,
    timestamp,
  );

  showNotification({
    message: {
      severity,
      title: message.title,
      description,
    },
  });
};
